import { HashRouter as Router, Route, Routes } from "react-router-dom";
import { useEffect } from "react";
import Homepage from "../pages/homepage/Homepage";

const AppRouter = () => {
  useEffect(() => {
    document.body.style.margin = "0px";
    return () => {
      document.body.style.margin = null;
    };
  }, []);

  return (
    <Router>
      <Routes>
        <Route exact path="/" element={<Homepage />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
